import React from "react";

import { queries } from "src/modules/htx/patient-list/queries";
import {
	useDesktopColumnProps,
	useMobileColumnProps
} from "src/modules/htx/patient-list/useColumnProps";
import { useNormalizePatient } from "src/modules/htx/patient-list/useNormalizePatient";
import { PatientList as PatientListShared } from "src/modules/shared/patient-list";

export const PatientList: React.FunctionComponent = () => {
	const normalizePatient = useNormalizePatient();
	const columns = useDesktopColumnProps();
	const mobile = useMobileColumnProps();
	return (
		<PatientListShared
			queries={queries}
			desktopColumns={columns}
			mobileColumns={mobile}
			normalizePatient={normalizePatient}
		/>
	);
};
